import { Box, Paper, MenuList as MuiMenuList } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled(Box)``

export const ActionIconBox = styled(Box)`
  width: 100%;
  padding: 8px;
  display: flex;
  justify-content: center;
  cursor: pointer;
`

export const ActionIcon = styled(Box)<{ disabled: boolean }>`
  ${({ disabled }) => css`
    width: fit-content;
    opacity: ${disabled ? 0.5 : 1};
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
  `}
`

export const MenuPaper = styled(Paper)`
  border-radius: 8px !important;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1) !important;
  padding: 16px !important;
  padding-top: 0px !important;
  margin-top: -10px !important;
  margin-left: 22px !important;
`

export const MenuList = styled(MuiMenuList)`
  padding: 0 !important;
`

export const CloseIconBox = styled(Box)`
  ${({ theme }) => css`
    padding: 10px 0px 8px 0px;
    margin-bottom: 16px;
    border-bottom: 1px solid ${theme.colors.blue.head};
    display: flex;
    justify-content: flex-end;
  `}
`

export const CloseIcon = styled(Box)`
  ${({ theme }) => css`
    svg {
      cursor: pointer;
      opacity: 0.7;
      color: ${theme.colors.secondary};
    }
  `}
`

export const MenuItemBox = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const MenuItem = styled(Box)<{ disabled: boolean }>`
  ${({ theme, disabled }) => css`
    display: flex;
    align-items: center;
    gap: 16px;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    padding: 10px 16px;
    border-radius: 8px;
    opacity: ${disabled ? 0.5 : 1};
    background: ${disabled ? theme.colors.gray.disabled : 'transparent'};
    cursor: ${disabled ? 'not-allowed' : 'pointer'};

    &:hover {
      transition: all ease 0.3s;
      border-radius: 8px;
      background: ${theme.colors.background.hover};
    }
  `}
`

export const Icon = styled(Box)`
  width: 18px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }
`
